// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"59b9635c4cd205823afa","655":"0445cf71dae90683c37e"}[chunkId] + ".js";
};